import { writable } from 'svelte/store';

export const user = writable({
  income: '72,000',
  moIncome: '',
  debt: 200,
  down: '70,000',
  credit: 700,
  apr: 5.73,
});
